import React, { useState, useEffect} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

import Autocomplete from "@material-ui/lab/Autocomplete";
import DateFnsUtils from "@date-io/date-fns";
import { timeZoneChanger } from "../../components/Cookies/Cookies";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import { format } from "date-fns";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
	itemColumn: {
		alignSelf: "center",
		textAlign: "left"
	}
}));

export default function CheckAddItem(props) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [glAccount, setGlAccount] = useState(null);
	const [qty, setQty] = useState('');
	const [reference, setReference] = useState('');
	const [description, setDescription] = useState('');
	const [amount, setAmount] = useState(0);
	const [selectedDate, setSelectedDate] = React.useState(null);
	const [btnDisabled, setBtnDisabled] = useState(true);

	const handleDateChange = (date) => {
		date = format(date, "yyyy-MM-dd");
		setSelectedDate(date);
	};

	useEffect(() => {
		timeZoneChanger(setSelectedDate);
		if (description && glAccount!=null && amount > 0) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [description,amount,glAccount]);

	const handleOpen = () => {
		setOpen(true);
		//reset field values
		setDescription('');
		setAmount('');
		setGlAccount(null);
	};

	const handleClose = () => {
		setOpen(false);
		//reset field values
		setDescription('');
		setAmount('');
		setGlAccount(null);
	};
	const {glAccounts, addItem} = props;

	const dummy_item_array = [{id: 1, itemname: 'item1'},{id: 2, itemname: 'item1'}];

	const selectGlAccountProps = {
		//options: dummy_item_array,
		options: glAccounts, //pass the items array as props from PurchaseOrderInformation
		// getOptionLabel: (option) => option.description + ' - ' + option.branchidno 
		getOptionLabel: (option) => option.description
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		let item = {
			date: selectedDate,
			description: description,
			amount: parseFloat(amount),
			id:  description.replace(" ", "") + Math.random().toString(36).substring(7) + Math.floor(Math.random() * 1000), // generate random id,
			gl_account: glAccount.description,
			gl_id: glAccount.id

		}
		addItem(item)
		handleClose();
    }

	return (
		<div>
			<Button variant="outlined" color="primary" onClick={handleOpen}>
				Add Row
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<h2 id="transition-modal-title">Add Entry</h2>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={3}>
								<Grid item xs={3} className={classes.itemColumn}>
									Date
								</Grid>
								<Grid item xs={9}>
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
												<KeyboardDatePicker
												disableToolbar
												variant="inline"
												format="MMM dd, yyyy"
												id="date-picker-inline"
												label="Select Date"
												value={selectedDate}
												onChange={handleDateChange}
												inputVariant="outlined"
												margin="normal"
												className={classes.date}
												KeyboardButtonProps={{
													"aria-label": "change date",
												}}/>
									</MuiPickersUtilsProvider>
								</Grid>
								<Grid item xs={3} className={classes.itemColumn}>
									Description
								</Grid>
								<Grid item xs={9}>
									<TextField
										required
										id="outlined-required"
										label="Description"
										variant="outlined"
										type="text"
										value={description}
										onChange={(e)=>{setDescription(e.target.value)}}
									/>
								</Grid>
								<Grid item xs={3} className={classes.itemColumn}>
									Amount
								</Grid>
								<Grid item xs={9}>
									<TextField
										required
										id="outlined-required"
										label="Amount"
										variant="outlined"
										type="number"
										value={amount}
										onKeyPress={(e) => { 
											if(e.key == '-'){
												e.preventDefault();
											}
										 }}
										onChange={e => {
											setAmount(e.target.value);
										}}
										onBlur={(e) => {
											if(parseFloat(e.target.value) > 0){
												setAmount(e.target.value);
											}else{
												setAmount(0);
											}
											//console.log(e.target.value);
										}}
									/>
								</Grid>
								<Grid item xs={3} className={classes.itemColumn}>
									GL Account
								</Grid>
								<Grid item xs={9}>
								<Autocomplete
										{...selectGlAccountProps}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Select GL Account"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												// console.log(newValue);
												setGlAccount(newValue);
											}else{
												setGlAccount(null);
											}
										}}
									/>
								</Grid>
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Close
								</Button>
								<Button disabled={btnDisabled} type="submit" variant="contained" color="primary">
									Add Entry
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
